export interface StaticChatCategory {
  id: number;
  title: string;
  tab_id: number | null;
  profession:
  | 'physician'
  | 'nurse'
  | 'obesity'
  | 'pharmacist'
  | 'surgeon'
  | string;
}

export interface StaticChatTab {
  id: number;
  img?: any;
  tab_name: string;
  label?: string;
  tab_value: string;
  active: 0 | 1;
  show_on_home: boolean;
  show_on_tabs_page: boolean;
  categories: StaticChatCategory[];
}

export const staticChatTabs: StaticChatTab[] = [
  {
    id: 13,
    tab_name: 'Your Clinical Case',
    label: 'clinicalCase',
    img: require('../../assets/images/homeTabs/clinicalCase.png'),
    tab_value: 'clinical_cases',
    active: 0,
    show_on_home: false,
    show_on_tabs_page: false,
    categories: [
      {
        id: 1,
        title: 'Differential Diagnosis',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 2,
        title: 'Clinical Decision',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 3,
        title: 'Treatment Options',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 4,
        title: 'Latest Treatment Options',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 5,
        title: 'Personalized Treatment Options',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 6,
        title: 'Drugs Treatment',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 7,
        title: 'Comparison of Drugs Treating Similar Conditions',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 8,
        title: 'Prognosis and Future Outcomes',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 9,
        title: 'Different Diagnostic Tools',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 10,
        title: 'Follow-up & Monitoring',
        tab_id: 1,
        profession: 'physician',
      },
      {
        id: 155,
        title: 'Multidisciplinary Medical Case',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 154,
        title: 'Lifeguards Specific Diseases Alerts',
        tab_id: null,
        profession: 'physician',
      },
      /////Nurse
      {
        id: 69,
        title: 'Differential Diagnosis',
        tab_id: null,
        profession: 'nurse',
      },
      {
        id: 70,
        title: 'Care Plan',
        tab_id: null,
        profession: 'nurse',
      },
      {
        id: 71,
        title: 'Medication Management',
        tab_id: null,
        profession: 'nurse',
      },
      {
        id: 72,
        title: 'Discharge Plan',
        tab_id: null,
        profession: 'nurse',
      },
      {
        id: 73,
        title: 'Post- Discharge',
        tab_id: null,
        profession: 'nurse',
      },
      {
        id: 74,
        title: 'Patient Education',
        tab_id: null,
        profession: 'nurse',
      },
      {
        id: 75,
        title: 'Patient Management- Evidence Based',
        tab_id: null,
        profession: 'nurse',
      },
      ///Obesity
      {
        id: 89,
        title:
          'What are the main causes of obesity, and how do they apply to my situation?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 90,
        title: 'What realistic weight loss goals should I set for myself?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 91,
        title:
          'What specific dietary changes should I consider to aid in my weight loss?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 92,
        title:
          'Are there particular foods or food groups I should avoid or include in my diet?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 93,
        title:
          'What types of physical activities are recommended for someone at my weight?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 99,
        title:
          'How can I incorporate more physical activity into my daily routine, especially if I have mobility issues?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 94,
        title:
          'How can I effectively track my weight loss and other health improvements?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 95,
        title:
          'What are the warning signs that I may not be losing weight healthily?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 96,
        title:
          'Once I reach my weight loss goal, how can I maintain my new weight? What are the best practices for preventing weight regain?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 97,
        title:
          'How does muscle mass versus body fat affect my weight and health? Should I focus on losing fat, gaining muscle, or both?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 98,
        title: 'I need diet plan that fits my case?',
        tab_id: null,
        profession: 'obesity',
      },
      {
        id: 158,
        title: 'Proactive & Adaptive Bed/Resource Management',
        tab_id: null,
        profession: 'obesity',
      },
      //Pharmacist
      {
        id: 76,
        title: 'Medication Reconciliation',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 77,
        title: 'Prescribing – Medication Safety',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 78,
        title: 'Prescribing – Dosing Based On Organ Function',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 79,
        title: 'Prescribing – Special Considerations',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 80,
        title: 'Prescribing – Clinical Decision Making and Guidelines',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 81,
        title: 'Prescribing – Infectious Diseases and Antimicrobial Therapy',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 82,
        title: 'Prescribing – Oncology & Chemotherapy',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 83,
        title: 'Administration – Medication Handling, Preparation and Infusion',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 84,
        title: 'Monitoring – Drug Interactions and Clinical Impact',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 85,
        title: 'Monitoring – Therapeutic Drug Monitoring and Safety',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 86,
        title: 'Patient Education and Discharge Planning',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 87,
        title: 'Toxicology and Emergency Management',
        tab_id: null,
        profession: 'pharmacist',
      },
      {
        id: 100,
        title: 'Advanced Diseases Prediction',
        tab_id: null,
        profession: 'pharmacist',
      },
      //Surgeon
      {
        id: 53,
        title: 'Differential Diagnosis',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 54,
        title: 'Clinical Decision',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 55,
        title:
          'Treatment Options including conservative and surgical management',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 56,
        title: 'Perioperative Management',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 58,
        title: 'Surgical Techniques',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 59,
        title: 'Novel Surgical Techniques',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 60,
        title: 'Advanced Clinical Decisions',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 61,
        title: 'Post Operative Complications, recovery time',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 62,
        title: 'Perioperative Management Considerations',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 63,
        title: 'Prognostic & Expected Outcomes',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 65,
        title:
          'Different Surgical Management Options, including risks and benefits',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 66,
        title: 'Diagnostic Tools & Imaging Studies',
        tab_id: null,
        profession: 'surgeon',
      },
    ],
  },
  {
    id: 3,
    tab_name: 'Q&A',
    tab_value: 'qna',
    label: 'qna',
    active: 0,
    show_on_home: false,
    show_on_tabs_page: false,
    img: require('../../assets/images/homeTabs/qna.png'),
    categories: [],
  },
  {
    id: 14,
    tab_name: 'Medical Reports',
    tab_value: 'medical_reports',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 11,
        title: 'Case Full Report',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 12,
        title: 'Discharge Report',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 64,
        title: 'Operation Report',
        tab_id: null,
        profession: 'surgeon',
      },
      {
        id: 88,
        title: 'Pharmacy Intervention Report',
        tab_id: null,
        profession: 'pharmacist',
      },
    ],
  },
  {
    id: 146,
    tab_name: 'Monitoring Diseases Progression',
    tab_value: 'monitoring\u0640disease_progression',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 146,
        title: 'Monitoring Diseases Progression Prediction',
        tab_id: null,
        profession: 'physician',
      },
    ],
  },
  {
    id: 147,
    tab_name: 'Functional Medicine Support',
    tab_value: 'functional_medicine_support',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 147,
        title: 'Functional Medicine',
        tab_id: null,
        profession: 'physician',
      },
    ],
  },
  {
    id: 148,
    tab_name: 'Personalized Genomic Analytics',
    tab_value: 'personalized_genomics_analytics',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 148,
        title: 'Personalized Genomic Analytics',
        tab_id: null,
        profession: 'physician',
      },
    ],
  },
  {
    id: 149,
    tab_name: 'Anomalies Detection',
    tab_value: 'anomalies_detection',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 149,
        title: 'Case Anomalies Detection',
        tab_id: null,
        profession: 'physician',
      },
    ],
  },
  {
    id: 20,
    tab_name: 'Diseases Prediction',
    tab_value: 'diseases_prediction',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 20,
        title: 'Diseases Prediction',
        tab_id: null,
        profession: 'pharmacist',
      },
    ],
  },
  {
    id: 50,
    tab_name: 'Survival Analysis',
    tab_value: 'survival_analysis',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 50,
        title: 'Survival Analysis',
        tab_id: null,
        profession: 'pharmacist',
      },
    ],
  },
  {
    id: 150,
    tab_name: 'Compare Your Case with Similar Cases',
    tab_value: 'compare_your_case_with_similar',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 150,
        title: 'Compare my Case with Similar Medical Cases',
        tab_id: null,
        profession: 'physician',
      },
    ],
  },
  {
    id: 22,
    tab_name: 'Lifeguards Predicted Alerts',
    tab_value: 'lifeguards_predicted_alerts',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 130,
        title: 'Lifeguards Predictive Alert- Pulmonary Embolism',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 131,
        title: 'Lifeguards Predictive Alert- Heart Attack',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 132,
        title: 'Lifeguards Predictive Alert- Heart Failure',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 133,
        title: 'Lifeguards Predictive Alert- Stroke',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 134,
        title: 'Lifeguards Predictive Alert- Sepsis and Septic Shock',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 135,
        title:
          'Lifeguards Predictive Alert- Aneurysm Rupture (aortic or cerebral)',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 136,
        title:
          'Lifeguards Predictive Alert- Acute Respiratory Distress Syndrome',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 137,
        title: 'Lifeguards Predictive Alert- Acute Kidney Injury',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 138,
        title: 'Lifeguards Predictive Alert- Severe COVID-19 Complications',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 139,
        title: 'Lifeguards Predictive Alert- Traumatic Brain Injury',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 140,
        title: 'Lifeguards Predictive Alert- Liver or Multi-organ Failure',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 141,
        title: 'Lifeguards Predictive Alert- Malignant Tumor Complications',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 142,
        title:
          'Lifeguards Predictive Alert- Fatal Arrhythmias (Ventricular Tachycardia, Ventricular Fibrillation)',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 143,
        title: 'Lifeguards Predictive Alert- Acute Mesenteric Ischemia',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 144,
        title:
          'Lifeguards Predictive Alert- Massive Hemorrhage or Bleeding Events',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 145,
        title:
          'Lifeguards Predictive Alert- Respiratory Collapse in Chronic Pulmonary Disease (COPD, Asthma)',
        tab_id: null,
        profession: 'physician',
      },
    ],
  },
  {
    id: 23,
    tab_name: 'Early-Stage Asymptomatic Disease',
    tab_value: 'early_stage_asymptomatic_diseas',
    active: 0,
    show_on_home: true,
    show_on_tabs_page: false,
    categories: [
      {
        id: 101,
        title: 'Early-Stage Asymptomatic Atherosclerosis Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 102,
        title:
          'Early-Stage Asymptomatic Neurodegenerative Diseases (Alzheimer’s & Parkinson’s)',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 103,
        title: 'Early-Stage Asymptomatic Infections',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 104,
        title:
          'Early-Stage Asymptomatic Pancreatic cancer Ovarian or ovarian cysts',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 105,
        title: 'Early-Stage Asymptomatic too small Lung nodules',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 106,
        title: 'Early-Stage Asymptomatic Breast Cancer',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 107,
        title:
          'Early-Stage Asymptomatic Pancreatic or Hepatic Fibrosis Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 108,
        title: 'Early-Stage Asymptomatic Latent or early HIV/Viral Infections',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 109,
        title: 'Early-Stage Asymptomatic Rare Genetic Mutations or Patterns',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 110,
        title: 'Early-Stage Asymptomatic early rheumatoid arthritis Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 114,
        title:
          'Early-Stage Asymptomatic Post-Surgical and Critical Care Complications Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 115,
        title: 'Early-Stage Asymptomatic Heart Attacks or Strokes Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 116,
        title: 'Early-Stage Asymptomatic Cardiovascular Conditions Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 117,
        title:
          'Early-Stage Asymptomatic Diabetic Complications, Chronic Kidney Disease, or Liver Failure',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 119,
        title: 'Early-Stage Asymptomatic Silent Aneurysms',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 120,
        title:
          'Early-Stage Asymptomatic Pulmonary Embolism or Deep Vein Thrombosis (DVT) Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 121,
        title: 'Early-Stage Asymptomatic Acute Cardiac Events',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 122,
        title: 'Early-Stage Asymptomatic Genetic Predispositions',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 123,
        title:
          'Early-Stage Asymptomatic Subclinical Kidney or Liver Disease Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 124,
        title: 'Early-Stage Asymptomatic Sepsis',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 125,
        title: 'Early-Stage Asymptomatic Multiple Sclerosis',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 126,
        title:
          'Early-Stage Asymptomatic Mild Cognitive Impairment Progressing to Dementias Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 127,
        title:
          'Early-Stage Asymptomatic Silent Cerebrovascular Disease Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 128,
        title:
          'Early-Stage Asymptomatic COPD and asthma deterioration Prediction',
        tab_id: null,
        profession: 'physician',
      },
      {
        id: 129,
        title: 'Early-Stage Asymptomatic Pulmonary Fibrosis Prediction',
        tab_id: null,
        profession: 'physician',
      },
    ],
  },
];

// Export differential diagnosis category IDs for easy access
// ID 1: Physician Differential Diagnosis
// ID 69: Nurse Differential Diagnosis
// ID 53: Surgeon Differential Diagnosis
export const DIFFERENTIAL_DIAGNOSIS_CATEGORY_IDS = [1, 69, 53];

export const TREATMENT_OPTIONS_HEADERS = [
  'treatment type',
  'treatment option',
  'drug',
  'class',
  'drug/class',
  'drug class',
  'case',
  'category',
  'condition',
  'treatment',
  'aspect'
];
